import { render, staticRenderFns } from "./FeSucGomez.vue?vue&type=template&id=07a95b80&"
import script from "./FeSucGomez.vue?vue&type=script&lang=js&"
export * from "./FeSucGomez.vue?vue&type=script&lang=js&"
import style0 from "./FeSucGomez.vue?vue&type=style&index=0&id=07a95b80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports